// @flow
import * as React from 'react';

import { Field } from 'redux-form';
import { FormRadio, FormSelect } from '../../../../components';

import {
	BYE_ROUNDS,
	getLeagueFinalFormat,
	league_tooltips,
} from '../../../../helpers';

type Props = {
	is_finals: boolean;
	league_size: any;
	is_final_start_round: boolean;
	finals_format: number;
	final_rounds: Array<{ value: number, text: string }>;
	start_round: number
};

export const AdvancedLeagueSettings = ({
	is_finals, league_size, is_final_start_round, final_rounds,
	start_round
}: Props) => {

	return (
		<div>
			<FormRadio
				label='League Finals Series'
				name='finals'
				elements={[
					{
						value: 1,
						text: 'Yes',
					},
					{
						value: 0,
						text: 'No',
					},
				]}
				tooltip={league_tooltips.finals}
				is_disabled={Number(start_round) > 21}
			/>

			<Field
				label='League Finals Series Format'
				name='finals_format'
				options={getLeagueFinalFormat({ league_size })}
				component={FormSelect}
				tooltip={league_tooltips.finals_format}
				is_disabled={!is_finals}
			/>

			<Field
				label='League Finals Start Round'
				name='finals_start_round'
				options={final_rounds}
				component={FormSelect}
				tooltip={league_tooltips.finals_start_round}
				is_disabled={!is_final_start_round}
			/>

			<Field
				label='Play Opponents'
				name='play_times'
				options={[
					{
						value: 'flexible',
						text: 'Flexible',
					},
					{
						value: 'once',
						text: 'Once',
					},
					{
						value: 'twice',
						text: 'Twice',
					},
				]}
				component={FormSelect}
				tooltip={league_tooltips.play_times}
			/>
			{BYE_ROUNDS.length ? (
				<FormRadio
					label='Bye Rounds'
					name='bye_rounds'
					elements={[
						{
							value: 1,
							text: 'On',
						},
						{
							value: 0,
							text: 'Off',
						},
					]}
					tooltip={league_tooltips.bye_rounds}
					is_disabled={false}
				/>
			) : null}

		</div>
	);
};

export default AdvancedLeagueSettings;


// WEBPACK FOOTER //
// ./src/pages/leagues/leaguesCreate/forms/AdvancedLeagueSettings.js